import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, serchSelectManage } from "@/mixins/index";
import { getAll, getGamePlatformId, getRelevanceAdvplaceId, getGamePlatform, getRelevanceAdvplace, updeadvRelativeings, productRelevanceAdvplatform, productAdvertisingRelevance, listNo } from "@/api/advRelation";
export default {
  name: "advRelation",
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      forming: {
        click_product_id: "",
        click_adv_platform_id: "",
        select_adv_platform_ids: "",
        select_adv_place_ids: ""
      },
      platformList: [],
      adv_platform: [],
      adv_place: [],
      platFormIds: [],
      adv_place_ids: [],
      multipleSelection: [],
      multipleSelection2: [],
      multipleSelection3: [],
      gameData: [],
      id: "",
      advId: "",
      total: 0,
      page: 1,
      gameshow: true,
      plshow: false,
      pkgshow: false,
      oneRow: {},
      towRow: {},
      productList: []
    };
  },
  created: function created() {},
  activated: function activated() {
    var _this = this;

    listNo().then(function (resq) {
      if (resq.status == 200) {
        _this.productList = resq.data;
        getAll().then(function (res) {
          if (res.status == 200) {
            _this.adv_place = res.data.adv_place;
            _this.platformList = res.data.platform;
            _this.adv_platform = res.data.adv_platform;

            if (_this.oneRow.id) {
              _this.platformclick(_this.oneRow, true);
            }
          }
        });
      }
    });
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      var _this$searchData = _objectSpread({}, this.searchData),
          game = _this$searchData.game,
          platform = _this$searchData.platform,
          channel = _this$searchData.channel,
          pkg = _this$searchData.pkg;

      var params = {
        game: game,
        platform: platform,
        channel: channel,
        pkg: pkg
      };
      listNo(params).then(function (resq) {
        if (resq.status == 200) {
          _this2.productList = resq.data;
          getAll().then(function (res) {
            if (res.status == 200) {
              _this2.adv_place = res.data.adv_place;
              _this2.platformList = res.data.platform;
              _this2.adv_platform = res.data.adv_platform;

              if (_this2.oneRow.id) {
                _this2.platformclick(_this2.oneRow, true);
              }
            }
          });
        }
      });
    },
    platformclick: function platformclick(row) {
      var _arguments = arguments,
          _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isHide, plat_id, _yield$productRelevan, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isHide = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
                _this3.oneRow = row;
                _this3.adv_place_ids = [];
                _this3.forming.select_adv_place_ids = '';
                _this3.id = row.id;
                _this3.forming.click_product_id = row.id;
                _this3.multipleSelection = [];
                plat_id = {
                  product_id: row.id
                };
                _context.next = 10;
                return productRelevanceAdvplatform(plat_id);

              case 10:
                _yield$productRelevan = _context.sent;
                data = _yield$productRelevan.data;

                _this3.adv_platform.forEach(function (e) {
                  data.adv_platform.forEach(function (v) {
                    if (e.adv_platform_id == v) {
                      _this3.multipleSelection.push(e);
                    }
                  });
                });

                _this3.handleSelectionChange(_this3.multipleSelection);

                _this3.plshow = true;
                _this3.pkgshow = false;

                if (_this3.towRow.adv_platform_id && isHide) {
                  _this3.advplatformClick(_this3.towRow);
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    advplatformClick: function advplatformClick(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var advplatform_id, _yield$getRelevanceAd, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.towRow = row;
                _this4.multipleSelection2 = [];
                _this4.advId = row.adv_platform_id;
                _this4.forming.click_adv_platform_id = row.adv_platform_id;
                advplatform_id = {
                  advplatform_id: row.adv_platform_id,
                  product_id: _this4.forming.click_product_id
                };
                _context2.next = 7;
                return getRelevanceAdvplaceId(advplatform_id);

              case 7:
                _yield$getRelevanceAd = _context2.sent;
                data = _yield$getRelevanceAd.data;

                _this4.adv_place.forEach(function (e) {
                  data.adv_place.forEach(function (v) {
                    if (e.adv_place_id == v) {
                      _this4.multipleSelection2.push(e);
                    }
                  });
                });

                _this4.handleSelectionChange2(_this4.multipleSelection2);

                _this4.pkgshow = true;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      var _this5 = this;

      this.$refs.multipleTable.clearSelection();

      if (rows) {
        rows.forEach(function (item) {
          _this5.$refs.multipleTable.toggleRowSelection(item);
        });
      }
    },
    handleSelectionChange2: function handleSelectionChange2(rows) {
      var _this6 = this;

      this.$refs.multipleTable2.clearSelection();

      if (rows) {
        rows.forEach(function (item) {
          _this6.$refs.multipleTable2.toggleRowSelection(item);
        });
      }
    },
    selectionChange: function selectionChange(val) {
      var _this7 = this;

      this.platFormIds = [];
      val.forEach(function (item) {
        _this7.platFormIds.push(item.adv_platform_id);
      });
    },
    addplatId: function addplatId() {
      var _this8 = this;

      this.forming["select_adv_platform_ids"] = this.platFormIds.join(",");
      this.forming["select_adv_place_ids"] = this.adv_place_ids.join(","); // this.form = JSON.parse(JSON.stringify(this.form))
      // if(this.forming.click_adv_platform_id){
      //   this.forming.click_adv_platform_id =  this.platFormIds.findIndex(i=>i == this.forming.click_adv_platform_id) > -1 ? this.forming.click_adv_platform_id :''
      // }

      productAdvertisingRelevance(this.forming).then(function (res) {
        if (res.status == 200) {
          _this8.$store.dispatch('d2admin/serchSelect/updadvchannels');

          _this8.$message({
            message: res.message,
            type: "success"
          });
        } else {
          _this8.$message.error(res.message);
        }
      });
    },
    selectionChange2: function selectionChange2(val) {
      var _this9 = this;

      this.adv_place_ids = [];
      val.forEach(function (item) {
        _this9.adv_place_ids.push(item.adv_place_id);
      });
    },
    addpkg: function addpkg() {
      var _this10 = this;

      var data = {
        advplatform_id: this.advId,
        adv_place_ids: this.adv_place_ids.join(",")
      };
      getRelevanceAdvplace(data).then(function (res) {
        if (res.status == 200) {
          _this10.$message({
            message: res.messgae,
            type: "success"
          });
        } else {
          _this10.$message.error(res.message);
        }
      });
    }
  }
};